import biLogger from 'web-bi-logger';
export const desktop = biLogger.factory({endpoint: 'hf'}).setDefaults({src: 19}).logger();
export const mobile = biLogger.factory({endpoint: 'mhp'}).setDefaults({src: 19}).logger();



// WEBPACK FOOTER //
// ./bi.js